import "./BuyNow.css"
import PurchaseSection from "./PurchaseSection/PurchaseSection"
import Description from "./Description/Description"
import Testimonial from "./Testimonal/Testimonial"
export default function BuyNowSection(){
    return(
    <>
        <PurchaseSection/>
        <Description/>
        <Testimonial/>
    </>)
}